<template>
    <keep-alive include="CollectorList">
        <router-view ></router-view>
    </keep-alive>
</template>

<script>
    export default {
        name: "Collector",
        created() {
            if (!this.common.loginInfo.isLogin){
                this.$router.push("/login")
            }
        }
    }
</script>

<style scoped>

</style>
